export {VscodeIcon} from './vscode-icon.js';
